export const capitalize = <T extends string>(str: T): Capitalize<T> =>
  ((str[0] ?? '').toUpperCase() + str.substring(1)) as Capitalize<T>;
